export const viewScanDialogSx = {
  dialogSx: {
    borderRadius: '0px',
    backgroundColor: 'rgba(169, 169, 169, 0.5)',
    backdropFilter: 'blur(8px)'
  },
  viewScanBoxSx: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '800 !important',
    fontSize: 'var(--font-size-18)',
    lineHeight: '27px',
    marginTop: '8px'
  },
  closeIconBtnSx: {
    height: '40px'
  },
  dialogContent: {
    paddingBottom: '0px'
  },
  listSx: {
    fontWeight: 400,
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-22)'
  },
  descTitleSx: {
    fontWeight: 400,
    fontSize: 'var(--font-size-15)',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  listItemSx: {
    paddingLeft: '10px',
    alignItems: 'baseline',
    paddingTop: '0px',
    paddingBottom: '0px'
  },
  listItemIcon: {
    minWidth: '20px'
  },
  circleIconSx: {
    fontSize: '8px',
    color: 'black'
  },
  primaryTypographyProps: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-22)',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  dialogActionsSx: {
    marginTop: '10px',
    marginBottom: '15px'
  },
  btnSx: {
    height: 10,
    py: 2.5,
    borderRadius: 0.6
  },
  scoreTooltipBxSx: {
    '&:hover': { cursor: 'pointer' }
  },
  scoreTooltipBtnSx: {
    width: 'max-content',
    height: 'Fixed (28px)',
    padding: '6px 12px 6px 12px',
    borderRadius: '5px',
    gap: '4px',
    border: '0px',
    color: 'var(--color-primary)',
    fontFamily: 'Inter !important',
    fontWeight: 500
  },
  pluginDialogSx: {
    '& .MuiPaper-root': {
      border: '1px solid var(--color-secondary)',
      backgroundColor: 'var(--color-success-bg-ultra)',
      padding: '24px',
      paddingBottom: '12px'
    },
    borderRadius: '0px !important',
    backgroundColor: 'rgba(169, 169, 169, 0.5)',
    backdropFilter: 'blur(8px)'
  }
};
